import { render, staticRenderFns } from "./WidgetBuilderBBF.vue?vue&type=template&id=7bc69367&scoped=true&"
import script from "./WidgetBuilderBBF.vue?vue&type=script&lang=js&"
export * from "./WidgetBuilderBBF.vue?vue&type=script&lang=js&"
import style0 from "./WidgetBuilderBBF.vue?vue&type=style&index=0&id=7bc69367&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc69367",
  null
  
)

export default component.exports